import router from '../router/index'
import vue from 'vue'
import { getToken, removeToken } from '@/utils/auth'
import { API_BASE_URL } from '@/config'
import { ajax } from 'jingxi'
window.requestMessageError = null
export default new ajax(
  {
    baseURL: API_BASE_URL,
    timeout: 3000000
    // openSign: true,
    // signVersion: '2.0'
  },
  config => {
    let tk = getToken()
    config.headers['token'] = tk
    return config
  },
  response => {
    /***
     * 状态码
     * 0 操作失败
     * 1 操作成功
     * 50000 token错误
     * 3 未登录
     * 4 数据不存在
     * 5 系统异常
     * 6 Token 过期或失效
     */
    if (
      response.data.code == 0 ||
      response.data.code == 4 ||
      response.data.code == 5
    ) {
      window.requestMessageError && window.requestMessageError.close()
      response.config.url.indexOf('saas/user/check') == -1 &&
        vue.prototype.$message.error(response.data.msg)
    }
    if (response.data.code == 3) {
      window.requestMessageError && window.requestMessageError.close()
      window.requestMessageError = vue.prototype.$message.error('请重新登录')
      setTimeout(() => {
        router.push('/login')
      }, 500)
    }
    if (response.data.code == 6 || response.data.code == 50000) {
      window.requestMessageError && window.requestMessageError.close()
      window.requestMessageError = vue.prototype.$message.error('请重新登录')
      removeToken()
      setTimeout(() => {
        router.push('/login')
      }, 500)
    }
    return response.data
  }
)
export const append = data => {
  const array = []
  if (!data) {
    return ''
  }
  for (let v in data) {
    array.push(`${v}=${data[v]}`)
  }
  return '?' + array.join('&')
}
